/**
 * Format specialty names consistently.
 * Capitalizes each word, handles hyphens (e.g., "multi-specialty" → "Multi-Specialty").
 */
export function formatSpecialty(specialty: string): string {
  return specialty
    .split(/[-\s]/)
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
    .join(specialty.includes('-') ? '-' : ' ');
}
